/* jshint esversion: 6 */
import { toast } from "react-toastify";

export const showTost = ({ title }) => {
  const toastId = `gomeet-${String(title || "").trim()}`;
  if (toast.isActive(toastId)) return null;

  toast(title, {
    toastId,
    position: "top-center",
    autoClose: 2500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    progress: undefined,
    theme: "light",
    className: "gomeet-toast",
  });
  return null;
};
